<app-spinner-overlay></app-spinner-overlay>

@if (generalita) {
  <div class="titolo-licenze">Gestione Licenze per utente</div>

  <div class="generalita">
    <div style="font-weight: 500">
      {{ utente?.ruolo?.descrizione }}
    </div>
    <div>
      {{ generalita }}
    </div>
  </div>
}

<div mat-dialog-content class="dialog-center-cont">
  <ng-scrollbar>
    <div style="padding-right: 20px">
      <div *ngIf="error">{{ error }}</div>
      <app-riepilogo-licenze [utente]="utente" *ngIf="utente"></app-riepilogo-licenze>

      <div class="spinner" *ngIf="!error && !utente">
        <mat-spinner style="height: 50px"></mat-spinner>
      </div>
    </div>
  </ng-scrollbar>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
</div>
